export default {
  methods: {
    dayMonth(string) {
      let date = new Date(string)

      let month = String(date.getMonth() + 1),
        day = String(date.getDate())

      return `${day.padStart(2, 0)}.${month.padStart(2, 0)}`
    },
    monthYear(string) {
      let date = new Date(string)

      let month = String(date.getMonth() + 1),
          year = date.getFullYear()

      return `${month.padStart(2, 0)}.${year}`
    },
    monthTextYear(string) {
      let date = new Date(string)

      let year = date.getFullYear()

      const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'Maj',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dec',
      ]

      return `${months[date.getMonth()]} ${year}`
    },
    minuteHour(string) {
      let date = new Date(string)

      let hour = String(date.getHours()),
        minute = String(date.getMinutes())

      return `${hour.padStart(2, 0)}:${minute.padStart(2, 0)}`
    },
    diffInSeconds(first, second){
      let firstDate = new Date(first),
          secondDate = new Date(second)

      return Math.ceil((secondDate - firstDate) / 1000)
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/app/mixins/helpers/DateMixin.js